// Dependecies
import React, { useState, useEffect } from 'react';

function useAlert() {
  const [alertUpdate, setAlertUpdate] = useState(false);
  const [messageError, setMessageError] = useState(false);
  const [messageAlert, setMessageAlert] = useState(false);

  useEffect(() => {
    const timer1 = setTimeout(() => {
      setAlertUpdate(false);
    }, 5000);

    return () => {
      clearTimeout(timer1);
    };
  }, [alertUpdate]);

  useEffect(() => {
    const timer2 = setTimeout(() => {
      setMessageAlert(false);
    }, 10000);

    return () => {
      clearTimeout(timer2);
    };
  }, [messageAlert]);

  useEffect(() => {
    const timer3 = setTimeout(() => {
      setMessageError(false);
    }, 5000);

    return () => {
      clearTimeout(timer3);
    };
  }, [messageError]);

  return {
    alertUpdate,
    messageError,
    messageAlert,
    setAlertUpdate,
    setMessageError,
    setMessageAlert,
  };
}

export default useAlert;
